import styled from 'styled-components'
import { ContentWrapper } from './Article.styles'

interface Props {
    contentHtml: string
    makeTextBolder?: boolean
    isDarkTheme?: boolean
}

const ArticleContentWrapper = styled(ContentWrapper)<{ isDarkTheme?: boolean }>`
    width: 100%;
`

const HTMLArticleContent = ({ contentHtml, makeTextBolder, isDarkTheme }: Props) => {
    return (
        <ArticleContentWrapper
            dangerouslySetInnerHTML={{ __html: contentHtml }}
            suppressHydrationWarning={true}
            makeTextBolder={makeTextBolder}
            isDarkTheme={isDarkTheme}
        />
    )
}

export default HTMLArticleContent
